module.exports = __webpack_public_path__ + "static/media/91926__tim-kahn__ding.5e91d9c2.wav";